"use strict";

exports.__esModule = true;
var _TicketListScreen = require("./TicketListScreen");
Object.keys(_TicketListScreen).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _TicketListScreen[key]) return;
  exports[key] = _TicketListScreen[key];
});